// Vuex connections module actions

import { API } from '@/config';
import { hParseToFilterCriteriaObjectRequiredByApi } from '@/utils/helpers';

import {
  FILL_LIST,
  SET_FILTERING_CRITERIA,
  SET_PAGE,
  UPDATE_NUMBER,
  REMOVE_NUMBER,
} from './mutations-types';

export default {

  async createNumber(context, params) {
    try {
      await API.put('/blacklist/createNumber', params);
      return;
    } catch (err) {
      console.log(err);
    }
  },
  async updateNumber({ commit }, params) {
    try {
      commit(UPDATE_NUMBER, params);
      await API.patch('/blacklist/updateNumber', params);
      return;
    } catch (err) {
      console.log(err);
    }
  },
  async removeNumber({ commit }, params) {
    try {
      await API.delete('/blacklist/removeNumber', { params });
      commit(REMOVE_NUMBER, params);
      return;
    } catch (err) {
      console.log(err);
    }
  },
  async getList({ state, commit }) {
    try {
      const params = {
        filtering_criteria: hParseToFilterCriteriaObjectRequiredByApi(state.filteringCriteria),
        page: state.list.page,
      };
      const { records, total } = (await API.get('/blacklist/getList', { params })).data.data;
      commit(FILL_LIST, { records, total });
    } catch (err) {
      console.log(err);
    }
  },
  filterList({ commit, dispatch }, params) {
    try {
      const filterCriteria = {};
      Object.keys(params).forEach((key) => {
        if (params[key] !== null && params[key] !== '' && params[key].length > 0) {
          filterCriteria[key] = {
            value: params[key],
            name: key,
            label: key,
          };
        }
      });

      commit(SET_FILTERING_CRITERIA, { ...filterCriteria });
      commit(SET_PAGE, { page: 1 });
      dispatch('getList');
    } catch (err) {
      console.log(err);
    }
  },
  clearFilteringCriteria({ commit }) {
    commit(SET_FILTERING_CRITERIA, {});
    commit(SET_PAGE, { page: 1 });
  },
  changePage({ commit, dispatch }, page) {
    commit(SET_PAGE, { page });
    dispatch('getList');
  },
};
